// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-39a36f8c]{display:none}.footer-footnote-links[data-v-39a36f8c]{text-align:center}.footer-footnote-links .sf-link[data-v-39a36f8c]:not(:last-child){border-right:1px solid #2e2d2c;padding-right:8px}.footer-footnote-links .sf-link[data-v-39a36f8c]:not(:first-child){padding-left:8px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
